module.exports = __webpack_public_path__ + "img/logo.591cf424.png";